/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';


class ReportController {
    public static $inject = [
        '$scope',
        '$http',
        'User',
        'Employee',
        'bsLoadingOverlayService',
        'Orgs',
    ];

    public user;
    public hasPermission;
    public who = 'all_subordinates';
    public org = null;
    public chart_options_bar = {};
    public chart_options_pie = {};

    public employeeChartDefs = [
        ['personal__nationality', 'pie', 'Employees by Nationality', 0],
        ['personal__gender', 'pie', 'Employees by Gender', 1],
        ['personal__religion', 'pie', 'Employees by Religion', 2],
        ['personal__marital_status', 'pie', 'Employees by Martital Status', 3],
        ['employment__structure__department', 'pie', 'Employees by Department', 4],
        ['employment__structure__office', 'pie', 'Employees by Office', 5],
        ['age', 'bar', 'Employees by Age', 6],
        ['benefit', 'pie', 'Employees by Benefit', 7],
    ];
    
    public employeeCharts: any = [];
    constructor(private $scope: angular.IScope,
                private $http: ng.IHttpService,
                private User: IUserService,
                private Employee: IEmpService,
                private bsLoadingOverlayService: IBsLoadingService,
                private Orgs: IOrgsService) {      
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        this.employeeChartDefs.map((chartDef) => {
            this.employeeCharts[chartDef[0]] = undefined;
        });
        this.user = User.getCurrentUser();
        if (User.hasPermission('org.change_employee')) {
            this.who = 'everyone';
        }
        this.hasPermission = User.hasPermission;
        Orgs.getOrgFromCache((response) => {
            this.org = response;
        });

        this.chart_options_bar = {
            responsive:true,
            maintainAspectRatio: true,
            legend: {
                display: false,
            }
        }

        this.chart_options_pie = {
            responsive:true,
            maintainAspectRatio: true,
            legend: {
                display: true,
                position: 'bottom'
            }
        }

        this.getCharts();

        $scope.$emit('$pageWithHelpVisited', 6);
    }

    public getCharts(): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.employeeChartDefs.map((chartDef) => {
            let url: string = '/api/employees/aggregate_extra/' + chartDef[0] + '/count';
            this.$http.get(url, {params: {who: this.who}}).then((r: any) => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                if (chartDef[1] === 'pie') {
                    this.employeeCharts.push({
                        id: chartDef[3],
                        type: chartDef[1],
                        title: chartDef[2],
                        values: r.data.map(i => i.value),
                        labels: r.data.map(i => i.label === undefined ? '---' : i.label),
                        legend: true
                    });
                } else {
                    this.employeeCharts.push({
                        id: chartDef[3],
                        type: chartDef[1],
                        title: chartDef[2],
                        values: [r.data.map(i => i.value)],
                        labels: r.data.map(i => i.label === undefined ? '---' : i.label),
                        legend: false
                    });
                }
            });
        });
    }
}

angular.module('beneple.global')
    .controller('ReportController', ReportController);

class TurnoverReportController {
    
    public static $inject = [
        '$http',
        'Orgs',
        'bsLoadingOverlayService',
    ];

    public user;
    public data;
    public year;
    public years;
    public months;
    public year_data;
    public chart_data;
    public employee_data;
    public turnover_chart_data;
    public chart_labels;
    public chart_series;
    public departments = [];
    public department = '';
    public turnover_options = {
                                scales: {
                                            yAxes: {
                                                ticks: {
                                                    fixedStepSize: 2
                                                }
                                            },
                                        },
                            };
    
    
    constructor(private $http: ng.IHttpService,
                private Org: IOrgsService,
                private bsLoadingOverlayService: IBsLoadingService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.load_chart();
        Org.getMyOrg().then((org) => {
            this.departments = [].concat.apply([],
                (org.extra.offices || []).map((o) => [].concat.apply([],
                    (o.divisions || []).map((d) =>
                        (d.departments || []).map((e) => e.name)))));
        });
    }

    public load_chart(): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.$http.get('/api/employees/turnover', {params: {department: this.department}}).then((r: any) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.data = r.data;

            this.years = r.data.years.map((year) => year.year);
            this.months = r.data.years.map((months) => months.months);
            r.data.years.map((year) => {
                this.year = year.year;
            });
            this.change_year();
        });
    }

    public change_year(): void {
        this.year_data = this.data.years.filter((year) => year.year === this.year)[0];
        this.chart_data = [[], [], [], []];
        this.employee_data = [];
        this.turnover_chart_data = [[]];
        this.chart_labels = [];
        this.year_data.months.map((month) => {
            this.chart_data[0].push(month.total);
            this.chart_data[1].push(month.join);
            this.chart_data[2].push(month.leave);
            this.chart_data[3].push(month.join - month.leave);
            this.turnover_chart_data[0].push((100-Number(month.turnover)).toFixed(2));
            this.chart_labels.push(month.month);
            this.employee_data.push(month.employee_data);
        });

    }
}

angular.module('beneple.global')
    .controller('TurnoverReportController', TurnoverReportController);


function format_number(num: number): string {
    let formatted: string = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return formatted;
}

function format_currency(currency: string, num: number): string {
    let formatted: string = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (currency && currency.length > 0) {
        return currency + ' ' + formatted;
    } else {
        return formatted;
    }
}



class GratuityReportController {
    public static $inject = [
        '$http',
        'Orgs',
        'bsLoadingOverlayService',
        'toaster',
        '$uibModal',
    ];

    public user;
    public data;
    public year;
    public years;
    public year_data;
    public chart_data;
    public turnover_chart_data;
    public chart_labels;
    public chart_series;
    public departments = [];
    public department = '';
    public chart_options =  {
              // tooltipTemplate: function(valueObj) {
              //     return valueObj.label + ": " + format_number(valueObj.value);
              // }
            }
    public currency = '';

    constructor(private $http: ng.IHttpService,
                private Org: IOrgsService,
                private bsLoadingOverlayService: IBsLoadingService,
                private toaster: any,
                private $uibModal: any,
        ) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        Org.getOrgFromCache(org => {
            if (org.extra.details && org.extra.details.currency) {
                this.currency = org.extra.details.currency;
            }
        });

        this.chart_options = {
            tooltips: {
                callbacks: {
                    // Add a space to the start of the label to create a gap between the legend and the label
                    label: (tooltipItem, _data) => format_currency(" " + this.currency, tooltipItem.value)
                }
            },

            scales: {
                yAxes: [{
                    ticks: {
                        // Include a dollar sign in the ticks
                        callback: (value, _index, _values) => format_currency(this.currency, value)
                    }
                }]
            }
        }
        this.load_chart();
    }

    public load_chart(): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.$http.get('/api/employees/gratuity', {params: {department: this.department}}).then((r: any) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.data = r.data;
            this.chart_data = [this.data.totals];
            this.chart_labels = this.data.months;

        });
    }


    public cta(): void {
            let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): any {
                $scope.confirmation = false;
                $scope.modalHeader = 'Gratuity Pot';
                $scope.modalDetail = 'Speak to us about creating a gratuity pot?';
                $scope.confirmButton = 'Request a callback';
                $scope.cancelButton = 'Cancel';

                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }]
        });
        modalInstance.result.then((result) => {
            if (result) {

                this.$http.post('/api/org/cta', {action: 'gratuity_pot'}).then((full_org) => {
                    this.toaster.pop('success', 'Message sent', 'One of our colleagues will contact you shortly');

                });
            } else {
                this.toaster.pop('warning', 'Cancelled', 'Action cancelled by user');
            }
        });
    }

}

angular.module('beneple.global')
    .controller('GratuityReportController', GratuityReportController);

class SalaryReportController {
    public static $inject = [
        '$http',
        'Orgs',
        'bsLoadingOverlayService',
    ];

    public user;
    public data;
    public year;
    public years;
    public year_data;
    public chart_data;
    public turnover_chart_data;
    public chart_labels;
    public departments = [];
    public department = '';
    public currency = '';
    public chart_options;

    constructor(private $http: ng.IHttpService,
                private Org: IOrgsService,
                private bsLoadingOverlayService: IBsLoadingService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        Org.getOrgFromCache(org => {
            if (org.extra.details && org.extra.details.currency) {
                this.currency = org.extra.details.currency;
            }
        });
        this.chart_options = {
            responsive:true,
            maintainAspectRatio: false,
            legend: {
                display: true,
                position: 'bottom'
            },
            tooltips: {
                callbacks: {
                    // Add a space to the start of the label to create a gap between the legend and the label
                    label: (tooltipItem, _data) => format_currency(" " + this.currency, tooltipItem.value)
                }
            },

            scales: {
                yAxes: [{
                    ticks: {
                        // Include a dollar sign in the ticks
                        callback: (value, _index, _values) => format_currency(this.currency, value)
                    }
                }]
            }

        }

        this.load_chart();
        Org.getMyOrg().then((org) => {
            // Load offices/divisions/departments
            this.departments = [].concat.apply([],
                (org.extra.offices || []).map((o) => [].concat.apply([],
                    (o.divisions || []).map((d) =>
                        (d.departments || []).map((e) => e.name)))));
        });
    }

    public format_number(num: number): string {
        let formatted: string = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return formatted;
    }

    public load_chart(): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.$http.get('/api/employees/salary', {params: {department: this.department}}).then((r: any) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.data = r.data;
            this.years = r.data.years.map((year) => year.year);
            r.data.years.map((year) => {
                // Create formatted text labels for graph
                year.increase_label = this.format_number(year.increase) + ' ' + this.currency;
                year.decrease_label = this.format_number(year.decrease) + ' ' + this.currency;
                year.total_label = this.format_number(year.total) + ' ' + this.currency;

                year.change = year.increase - year.decrease;
                year.change_label = (year.change > 0 ? '+' : '') + this.format_number(year.change) + ' ' + this.currency;
                // Map Year Name
                this.year = year.year;
            });
            this.change_year();
        });
    }

    public change_year(): void {
        this.year_data = this.data.years.filter((year) => year.year === this.year)[0];
        this.chart_data = [[], [], [], []];
        this.turnover_chart_data = [[]];
        this.chart_labels = [];
        this.year_data.months.map((month) => {
            this.chart_data[0].push(month.total);
            this.chart_data[1].push(month.increase);
            this.chart_data[2].push(month.decrease);
            this.chart_data[3].push(month.increase - month.decrease);
            this.chart_labels.push(month.month);
        });
    }
}

angular.module('beneple.global')
    .controller('SalaryReportController', SalaryReportController);

class LeaveReportController {
    public static $inject = [
        '$http',
        'Orgs',
        'bsLoadingOverlayService',
    ];

    public user;
    public data;
    public year;
    public years;
    public year_data;
    public employee_data;
    public chart_data;
    public chart_labels;
    public departments = [];
    public department = '';
    constructor(private $http: ng.IHttpService,
                private Org: IOrgsService,
                private bsLoadingOverlayService: IBsLoadingService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.load_chart();
        Org.getMyOrg().then((org) => {
            this.departments = [].concat.apply([],
                (org.extra.offices || []).map((o) => [].concat.apply([],
                    (o.divisions || []).map((d) =>
                        (d.departments || []).map((e) => e.name)))));
        });
    }

    public format_number(num: number): string {
        let formatted: string = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return formatted;
    }

    public load_chart(): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.$http.get('/api/employees/leave', {params: {department: this.department}}).then((r: any) => {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.data = r.data;
            this.years = r.data.years.map((year) => year.year);
            r.data.years.map((year) => {
                // Create formatted text labels for graph
                year.paid_label = this.format_number(year.paid);
                year.sick_label = this.format_number(year.sick);
                year.unpaid_label = this.format_number(year.unpaid);
                year.compassionate_label = this.format_number(year.compassionate);
                year.maternity_label = this.format_number(year.maternity);
                year.paternity_label = this.format_number(year.paternity);
                year.total_label = this.format_number(year.total);

                this.year = year.year;

            });
            this.change_year();
        });
    }

    public change_year(): void {
        this.year_data = this.data.years.filter((year) => year.year === this.year)[0];
        this.chart_data = [[], [], [], [], [], [], []];
        this.employee_data = [];

        this.chart_labels = [];
        this.year_data.months.map((month) => {
            this.chart_data[0].push(month.total);
            this.chart_data[1].push(month.paid);
            this.chart_data[2].push(month.sick);
            this.chart_data[3].push(month.unpaid);
            this.chart_data[4].push(month.maternity);
            this.chart_data[5].push(month.paternity);
            this.chart_data[6].push(month.compassionate);
            this.chart_labels.push(month.month);
            this.employee_data.push(month.employee_data);
        });
    }
}

angular.module('beneple.global')
    .controller('LeaveReportController', LeaveReportController);

class CustomReportController {
    public static $inject = [
        '$http',
        'Orgs',
        'Employee',
        'bsLoadingOverlayService',
        '$scope',
    ];

    public user;
    public data;
    public year;
    public years;
    public year_data;
    public chart_data;
    public turnover_chart_data;
    public chart_labels;
    public chart_series;
    public offices = [];
    public office = '';
    public divisions = [];
    public division = '';
    public departments = [];
    public department = '';
    public basicInformation = [];
    public employmentInformation = [];
    public bankingInformation = [];
    public medicalInformation = [];
    public officeFilter = [];
    public divisionFilter = [];
    public departmentFilter = [];
    public maritalStatusFilter = [];
    public genderFilter = [];
    public languagesFilter = [];
    public religionFilter = [];
    public contractTypeFilter = [];
    public reportName: string = '';
    constructor(private $http: ng.IHttpService,
                private Org: IOrgsService,
                private Emp: IEmpService,
                private bsLoadingOverlayService: IBsLoadingService,
                private $scope: ng.IScope) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.reportName = 'employee_export-' + moment().format('DDMMYYY_HHmmss');
        Org.getMyOrg().then((org) => {
            // Load Office filter
            this.offices = [].concat.apply([],
                (org.extra.offices || []).map((o) => o.name));

            for (let i: number = 0; i < this.offices.length; ++i) {
                let office: any = this.offices[i];
                if (office !== '---') {
                    this.officeFilter.push({title: office, done: false});
                }
            }
            // Load Division filter
            this.divisions = [].concat.apply([],
                (org.extra.offices || []).map((o) => [].concat.apply([],
                    (o.divisions || []).map((d) => d.name))));

            for (let i: number = 0; i < this.divisions.length; ++i) {
                let division: any = this.divisions[i];
                if (division !== '---') {
                    this.divisionFilter.push({title: division, done: false});
                }
            }
            // Load Department filter
            this.departments = [].concat.apply([],
                (org.extra.offices || []).map((o) => [].concat.apply([],
                    (o.divisions || []).map((d) =>
                        (d.departments || []).map((e) => e.name)))));

            for (let i: number = 0; i < this.departments.length; ++i) {
                let department: any = this.departments[i];
                if (department !== '---') {
                    this.departmentFilter.push({title: department, done: false});
                }
            }
        });

        Emp.loadSchema().then((response: any) => {
            let schema: any = response.data;
            // getTitlesBySchema in orgs.services.ts throws
            // exception max stack size reached so for now
            // a quick hack to get it working
            let personal: any = schema.properties.personal.properties;
            this.basicInformation.push({title: personal.first_name.title, done: false});
            this.basicInformation.push({title: personal.last_name.title, done: false});
            this.basicInformation.push({title: 'Email', done: false});
            let contact: any = personal.contact.properties;
            let homeContact: string = 'Home';
            let workContact: string = 'Work';
            this.basicInformation.push({title: homeContact + ' ' + contact.home.properties.email.title, done: false});
            this.basicInformation.push({title: personal.birth_date.title, done: false});
            this.basicInformation.push({
                title: homeContact + ' ' + contact.home.properties.phone_number.title,
                done: false
            });
            this.basicInformation.push({
                title: homeContact + ' ' + contact.home.properties.address.title,
                done: false
            });
            this.basicInformation.push({
                title: workContact + ' ' + contact.work.properties.phone_number.title,
                done: false
            });
            this.basicInformation.push({
                title: workContact + ' ' + contact.work.properties.address.title,
                done: false
            });
            this.basicInformation.push({
                title: workContact + ' ' + contact.work.properties.mobile_number.title,
                done: false
            });
            this.basicInformation.push({title: personal.languages.title, done: false});
            this.basicInformation.push({title: personal.religion.title, done: false});
            this.basicInformation.push({title: personal.nationality.title, done: false});
            this.basicInformation.push({title: personal.gender.title, done: false});
            this.basicInformation.push({title: personal.marital_status.title, done: false});
            let employment: any = schema.properties.employment.properties;
            let medical: any = schema.properties.personal.properties.health.properties;
            let docs: any = employment.documents.items.properties;

            this.basicInformation.push({title: docs.type.enum[2] + ' ' + docs.number.title, done: false});
            this.basicInformation.push({title: docs.type.enum[2] + ' ' + docs.expiry_date.title, done: false});

            let emergencyContact: any = contact.emergency.title;
            this.basicInformation.push({
                title: emergencyContact + ' ' + contact.emergency.properties.name.title,
                done: false
            });
            this.basicInformation.push({
                title: emergencyContact + ' ' + contact.emergency.properties.relation.title,
                done: false
            });
            this.basicInformation.push({
                title: emergencyContact + ' ' + contact.emergency.properties.address.title,
                done: false
            });
            this.basicInformation.push({
                title: emergencyContact + ' ' + contact.emergency.properties.phone_number.title,
                done: false
            });

            this.basicInformation.push({title: docs.type.enum[0] + ' ' + docs.number.title, done: false});
            this.basicInformation.push({title: docs.type.enum[0] + ' ' + docs.expiry_date.title, done: false});

            this.employmentInformation.push({title: schema.properties.employment.title, done: false});
            this.employmentInformation.push({
                title: schema.properties.employment.properties.structure.properties.office.title,
                done: false
            });
            this.employmentInformation.push({
                title: schema.properties.employment.properties.structure.properties.division.title,
                done: false
            });
            this.employmentInformation.push({
                title: schema.properties.employment.properties.structure.properties.department.title,
                done: false
            });
            this.employmentInformation.push({title: employment.start_date.title, done: false});
            this.employmentInformation.push({title: employment.contract.properties.contract_type.title, done: false});
            this.employmentInformation.push({title: docs.type.enum[1] + ' ' + docs.number.title, done: false});
            this.employmentInformation.push({title: docs.type.enum[1] + ' ' + docs.expiry_date.title, done: false});
            this.employmentInformation.push({title: 'Manager', done: false});

            this.bankingInformation.push({title: employment.bank_account.properties.account_name.title, done: false});
            this.bankingInformation.push({title: employment.bank_account.properties.account_number.title, done: false});
            this.bankingInformation.push({title: employment.bank_account.properties.bank_route.title, done: false});
            this.bankingInformation.push({title: employment.bank_account.properties.iban_number.title, done: false});
            this.bankingInformation.push({title: employment.bank_account.properties.bank_name.title, done: false});
            this.bankingInformation.push({title: employment.bank_account.properties.bank_address.title, done: false});

            this.medicalInformation.push({title: medical.medical_record_number.title, done: false, field: 'medical_record_number'});
            this.medicalInformation.push({title: medical.covid_vaccination_received.title, done: false, field: 'covid_vaccination_received'});
            this.medicalInformation.push({title: medical.covid_vaccination_second_date.title, done: false, field: 'covid_vaccination_second_date'});

            for (let i: number = 0; i < personal.gender.enum.length; ++i) {
                let gender: any = personal.gender.enum[i];
                if (gender !== '---') {
                    this.genderFilter.push({title: gender, done: false});
                }
            }
            for (let i: number = 0; i < personal.marital_status.enum.length; ++i) {
                let marital_status: any = personal.marital_status.enum[i];
                if (marital_status !== '---') {
                    this.maritalStatusFilter.push({title: marital_status, done: false});
                }
            }
            for (let i: number = 0; i < personal.languages.items.enum.length; ++i) {
                let languages: any = personal.languages.items.enum[i];
                if (languages !== '---') {
                    this.languagesFilter.push({title: languages, done: false});
                }
            }
            for (let i: number = 0; i < personal.religion.enum.length; ++i) {
                let religion: any = personal.religion.enum[i];
                if (religion !== '---') {
                    this.religionFilter.push({title: religion, done: false});
                }
            }
            for (let i: number = 0; i < employment.contract.properties.contract_type.enum.length; ++i) {
                let contractType: any = employment.contract.properties.contract_type.enum[i];
                if (contractType !== '---') {
                    this.contractTypeFilter.push({title: contractType, done: false});
                }
            }
        });
    }

    // Solution for the check all was inspired by
    // http://plnkr.co/edit/IQA9kq?p=preview
    public selectAllBasic(): void {
        let allChecked: boolean = !this.isAllChecked();
        angular.forEach(this.basicInformation, function (basicField: any): void {
            basicField.done = allChecked;
        });
    }

    public isAllChecked(): boolean {
        let allChecked: any = this.basicInformation.reduce(function (basic: any, basicField: any): any {
            return basic + (basicField.done ? 1 : 0);
        }, 0);
        return (allChecked === this.basicInformation.length);
    }

    public selectAllEmployment(): void {
        let allChecked: boolean = !this.isAllEmploymentChecked();
        angular.forEach(this.employmentInformation, function (employmentField: any): any {
            employmentField.done = allChecked;
        });
    }

    public isAllEmploymentChecked(): boolean {
        let allChecked: any = this.employmentInformation.reduce(function (employ: any, employmentField: any): any {
            return employ + (employmentField.done ? 1 : 0);
        }, 0);
        return (allChecked === this.employmentInformation.length);
    }

    public selectAllBanking(): void {
        let allChecked: boolean = !this.isAllBankingChecked();
        angular.forEach(this.bankingInformation, function (bankingField: any): any {
            bankingField.done = allChecked;
        });
    }

    public isAllBankingChecked(): boolean {
        let allChecked: any = this.bankingInformation.reduce(function (bank: any, bankingField: any): any {
            return bank + (bankingField.done ? 1 : 0);
        }, 0);
        return (allChecked === this.bankingInformation.length);
    }

    public selectAllMedical(): void {
        let allChecked: boolean = !this.isAllMedicalChecked();
        angular.forEach(this.medicalInformation, function (medicalField: any): any {
            medicalField.done = allChecked;
        });
    }

    public isAllMedicalChecked(): boolean {
        let allChecked: any = this.medicalInformation.reduce(function (medical: any, medicalField: any): any {
            return medical + (medicalField.done ? 1 : 0);
        }, 0);
        return (allChecked === this.medicalInformation.length);
    }

    public selectedHeaderFields(): string {
        let selectedFields: any = [];
        for (let i: number = 0; i < this.basicInformation.length; ++i) {
            let field: any = this.basicInformation[i];
            if (field.done) {
                let title: any = ((field.title).replace(/ /g, '_')).toLowerCase();
                selectedFields.push(title);
            }
        }
        for (let i: number = 0; i < this.employmentInformation.length; ++i) {
            let field: any = this.employmentInformation[i];
            if (field.done) {
                let title: any = ((field.title).replace(/ /g, '_')).toLowerCase();
                selectedFields.push(title);
            }
        }
        for (let i: number = 0; i < this.bankingInformation.length; ++i) {
            let field: any = this.bankingInformation[i];
            if (field.done) {
                let title: any = ((field.title).replace(/ /g, '_')).toLowerCase();
                selectedFields.push(title);
            }
        }
        for (let i: number = 0; i < this.medicalInformation.length; ++i) {
            let field: any = this.medicalInformation[i];
            if (field.done) {
                selectedFields.push(field.field);
            }
        }
        return selectedFields.toString();
    }

    public selectAllOffice(): void {
        let allChecked: boolean = !this.isAllOfficeChecked();
        angular.forEach(this.officeFilter, function (officeFilter: any): any {
            officeFilter.done = allChecked;
        });
    }

    public isAllOfficeChecked(): boolean {
        let allChecked: any = this.officeFilter.reduce(function (office: any, officeFilter: any): any {
            return office + (officeFilter.done ? 1 : 0);
        }, 0);

        return (allChecked === this.officeFilter.length);
    }

    public selectAllDivision(): void {
        let allChecked: boolean = !this.isAllDivisionChecked();
        angular.forEach(this.divisionFilter, function (divFilter: any): any {
            divFilter.done = allChecked;
        });
    }

    public isAllDivisionChecked(): boolean {
        let allChecked: any = this.divisionFilter.reduce(function (div: any, divFilter: any): any {
            return div + (divFilter.done ? 1 : 0);
        }, 0);
        return (allChecked === this.divisionFilter.length);
    }

    public selectAllDep(): void {
        let allChecked: boolean = !this.isAllDepChecked();
        angular.forEach(this.departmentFilter, function (departFilter: any): any {
            departFilter.done = allChecked;
        });
    }

    public isAllDepChecked(): boolean {
        let allChecked: any = this.departmentFilter.reduce(function (depart: any, departFilter: any): any {
            return depart + (departFilter.done ? 1 : 0);
        }, 0);
        return (allChecked === this.departmentFilter.length);
    }

    public selectAllMaritalStatus(): void {
        let allChecked: boolean = !this.isAllMaritalStatusChecked();
        angular.forEach(this.maritalStatusFilter, function (msFilter: any): any {
            msFilter.done = allChecked;
        });
    }

    public isAllMaritalStatusChecked(): boolean {
        let allChecked: any = this.maritalStatusFilter.reduce(function (ms: any, msFilter: any): any {
            return ms + (msFilter.done ? 1 : 0);
        }, 0);
        return (allChecked === this.maritalStatusFilter.length);
    }

    public selectAllGender(): void {
        let allChecked: boolean = !this.isAllGenderChecked();
        angular.forEach(this.genderFilter, function (gendFilter: any): any {
            gendFilter.done = allChecked;
        });
    }

    public isAllGenderChecked(): boolean {
        let allChecked: any = this.genderFilter.reduce(function (gend: any, gendFilter: any): any {
            return gend + (gendFilter.done ? 1 : 0);
        }, 0);
        return (allChecked === this.genderFilter.length);
    }

    public selectAllLanguages(): void {
        let allChecked: boolean = !this.isAllLanguagesChecked();
        angular.forEach(this.languagesFilter, function (langFilter: any): any {
            langFilter.done = allChecked;
        });
    }

    public isAllLanguagesChecked(): boolean {
        let allChecked: any = this.languagesFilter.reduce(function (lang: any, langFilter: any): any {
            return lang + (langFilter.done ? 1 : 0);
        }, 0);
        return (allChecked === this.languagesFilter.length);
    }

    public selectAllReligion(): void {
        let allChecked: boolean = !this.isAllReligionChecked();
        angular.forEach(this.religionFilter, function (relFilter: any): any {
            relFilter.done = allChecked;
        });
    }

    public isAllReligionChecked(): boolean {
        let allChecked: any = this.religionFilter.reduce(function (rel: any, relFilter: any): any {
            return rel + (relFilter.done ? 1 : 0);
        }, 0);
        return (allChecked === this.religionFilter.length);
    }

    public selectAllType(): void {
        let allChecked: boolean = !this.isAllTypeChecked();
        angular.forEach(this.contractTypeFilter, function (contractFilter: any): any {
            contractFilter.done = allChecked;
        });
    }

    public isAllTypeChecked(): boolean {
        let allChecked: any = this.contractTypeFilter.reduce(function (contract: any, contractFilter: any): any {
            return contract + (contractFilter.done ? 1 : 0);
        }, 0);
        return (allChecked === this.contractTypeFilter.length);
    }

    public selectedOfficeFilters(): string {
        let selectedFilters: any = [];
        for (let i: number = 0; i < this.officeFilter.length; ++i) {
            let filter: any = this.officeFilter[i];
            if (filter.done) {
                let title: string = '&office='.concat(filter.title);
                selectedFilters.push(title);
            }
        }
        if (this.isAllDepChecked()) {
            return '';
        }
        return selectedFilters.join('');
    }

    public selectedDivisionFilters(): string {
        let selectedFilters: any = [];
        for (let i: number = 0; i < this.divisionFilter.length; ++i) {
            let filter: any = this.divisionFilter[i];
            if (filter.done) {
                let title: string = '&division='.concat(filter.title);
                selectedFilters.push(title);
            }
        }
        if (this.isAllDivisionChecked()) {
            return '';
        }
        return selectedFilters.join('');
    }

    public selectedDepartmentFilters(): any {
        let selectedFilters: any = [];
        for (let i: number = 0; i < this.departmentFilter.length; ++i) {
            let filter: any = this.departmentFilter[i];
            if (filter.done) {
                let title: string = '&department='.concat(filter.title);
                selectedFilters.push(title);
            }
        }
        if (this.isAllDepChecked()) {
            return '';
        }
        return selectedFilters.join('');
    }

    public selectedMaritalStatusFilters(): string {
        let selectedFilters: any = [];
        for (let i: number = 0; i < this.maritalStatusFilter.length; ++i) {
            let filter: any = this.maritalStatusFilter[i];
            if (filter.done) {
                let title: string = '&marital_status='.concat(filter.title);
                selectedFilters.push(title);
            }
        }
        if (this.isAllGenderChecked()) {
            return '';
        }
        return selectedFilters.join('');
    }

    public selectedGenderFilters(): string {
        let selectedFilters: any = [];
        for (let i: number = 0; i < this.genderFilter.length; ++i) {
            let filter: any = this.genderFilter[i];
            if (filter.done) {
                let title: string = '&gender='.concat(filter.title);
                selectedFilters.push(title);
            }
        }
        if (this.isAllGenderChecked()) {
            return '';
        }
        return selectedFilters.join('');
    }

    public selectedLanguagesFilters(): any {
        let selectedFilters: any = [];
        for (let i: number = 0; i < this.languagesFilter.length; ++i) {
            let filter: any = this.languagesFilter[i];
            if (filter.done) {
                let title: string = '&languages='.concat(filter.title);
                selectedFilters.push(title);
            }
        }
        if (this.isAllLanguagesChecked()) {
            return '';
        }
        return selectedFilters.join('');
    }
    public selectedReligionFilters(): string {
        let selectedFilters: any = [];
        for (let i: number = 0; i < this.religionFilter.length; ++i) {
            let filter: any = this.religionFilter[i];
            if (filter.done) {
                let title: string = '&religion='.concat(filter.title);
                selectedFilters.push(title);
            }
        }
        if (this.isAllReligionChecked()) {
            return '';
        }
        return selectedFilters.join('');
    }

    public selectedTypeFilters(): string {
        let selectedFilters: any = [];
        for (let i: number = 0; i < this.contractTypeFilter.length; ++i) {
            let filter: any = this.contractTypeFilter[i];
            if (filter.done) {
                let title: string = '&contract_type='.concat(filter.title);
                selectedFilters.push(title);
            }
        }
        if (this.isAllTypeChecked()) {
            return '';
        }
        return selectedFilters.join('');
    }

    public emitEvent(eventName: string, eventAddData?: string): void {
        this.$scope.$emit('$EL', eventName, eventAddData);
    }

}

angular.module('beneple.global')
    .controller('CustomReportController', CustomReportController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/report.controller.ts